import Tpl from "./Tpl";
import {broadcastSendBTContext, onBroadcastNeedBTContext} from "../../api";
import {_compareVersion, _device, _logWaring} from "../../common/m_base/util";

export default class BigTpl extends Tpl {
    constructor(arg = {
        // campaignList: [],
        unit: {}
    }) {
        super(arg)

        // 表明当前模板如果要成功加载, 至少需要多少个 campaign
        this.expectCampaignNumber = 2

        // 存储通过当前大模板创建的子模板列表
        this.tplList = []
        this.tplIndexList = []

        this.unit = arg.unit || {}

        this.campaignList = []
    }

    init({JsBridgeRes}) {
        super.init({JsBridgeRes});

        window.onBroadcastNeedBTContext = onBroadcastNeedBTContext
        onBroadcastNeedBTContext({
            cb: async res => {
                console.log('监听到子模板对 BTContext 的需求', res)
                let subTplId = res.param.data.subTplId
                let data = {
                    subTplId,
                    MTG_SDKContext
                }
                console.log('开始广播 BTContext', data)
                await broadcastSendBTContext({unitId: this.unitId, data})
            }
        })
    }

    allTplPreloadFinished() {
        let isAllFinished = true
        for (let curTplItem of this.tplIndexList) {
            if (curTplItem.isPageLoadFinished === false) {
                isAllFinished = false
            }
        }
        return isAllFinished
    }

    show(res) {
        super.show(res)
    }

    /**
     * 针对 Android SDK 的兼容代码
     * 背景:
     * Android 大模板版本业务上应该由 H5 发送 pv_urls (为了保证后续模板交互设计的灵活性),
     * 但某些版本的 Android SDK 无论 H5 是否发送 pv_urls, 依然会额外再发送一次, 这里是不符合产品需求和期望的.
     * 解决方案:
     * 考虑到 SDK 已发版, 可能已经有少量用户开始使用, 综合讨论评估, H5 这边来做规避成本代价最小.
     * 所以 H5 在 "大模板类" 中针对父类的 reportPvUrls 做了一次重写,
     * 如果匹配到 Android 大模板特定版本 (MAL_12.2.0), 则不上报 pv_urls
     */
    reportPvUrls() {
        let isAndroid = _device().isAndroid
        let currentSDKVersion = this.getPureSDKVersion()
        console.log({isAndroid, currentSDKVersion})

        // 需要屏蔽 pv_urls 上报的安卓版本黑名单
        let androidVersionBlackList = ['12.2.0']
        let isVersionNeedAvoid = androidVersionBlackList.filter(versionNeedAvoid => {
            return _compareVersion(currentSDKVersion, versionNeedAvoid) === 0
        }).length > 0

        if (isAndroid && isVersionNeedAvoid) {
            // 特定版本: SDK 会在点击二选一广告时发送 pv_urls
            _logWaring('由于匹配到当前系统为安卓, 且 SDK 属于特定版本, 所以 H5 不再上报 pv_urls')
        } else {
            console.log('当前 SDK 不属于特定版本(SDK 并不会发送 pv_urls), 所以 H5 需要正常上报 pv_urls')
            super.reportPvUrls()
        }
    }
}